import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal,Badge } from 'react-bootstrap';
import axios from 'axios';

const View = ({ show, onClose, selectedId }) => {

  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [datas, setData] = useState([]);

  useEffect(() => {
      axios.get(`${baseURL}/managelead/${selectedId}`)
        .then(response => {
          setData(response.data);
        })
        .catch(error => {
          console.error('There was an error fetching the posts!', error);
        });

  }, []);

  return (
    <Modal show={show} size="md">
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <div className='d-flex align-items-center gap-3 flex-wrap'>
            <h3 className="modal-title text-white">View Lead</h3>
            <div className="ms-1 me-1 fw-bold text-white">-</div>
            <Badge bg="none" className='py-1 px-2 fs-4 border border-white shadow-lg text-white'>{datas.lead_status_name}</Badge>
          </div>
          <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Lead</label>
              <label className='text-black fs-6 font-w500'>{datas.lead_name}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
              <label className='text-black fs-6 font-w500'>{datas.mobile_no}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Email ID</label>
              <label className='text-black fs-6 font-w500 text-break'>{datas.email_id ? datas.email_id : '-'}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Area</label>
              <label className='text-black fs-6 font-w500'>{datas.area_name}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Lead Source</label>
              <label className='text-black fs-6 font-w500'>{datas.lead_sources_name}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Lead Type</label>
              <label className='text-black fs-6 font-w500'>{datas.lead_type_name}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Product</label>
              <label className='text-black fs-6 font-w500'>{datas.product_names ? datas.product_names : '-'}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Sales Person</label>
              <label className='text-black fs-6 font-w500'>{datas.sales_person ? datas.sales_person : '-'}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Latitude</label>
              <label className='text-black fs-6 font-w500'>{datas.latitude ? datas.latitude : '-'}</label>
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
              <label className='text-gray-800 font-w500 fs-7'>Longitude</label>
              <label className='text-black fs-6 font-w500'>{datas.longitude ? datas.longitude : '-'}</label>
            </div>
          </div>
          <div className="row mb-2">
            <label className="col-12 text-gray-800 font-w500 fs-7">Address </label>
            <label className="col-12 text-black fs-6 font-w500">&emsp;&emsp; {datas.address ? datas.address : '-'}</label>
          </div>
          <div className="row mb-2">
            <label className="col-12 text-gray-800 font-w500 fs-7">Description </label>
            <label className="col-12 text-black fs-6 font-w500">&emsp;&emsp; {datas.description ?  datas.description : '-'}</label>
          </div>
        </div>
      </div>
    </Modal >
  );
};

export default View;
